module.exports = __webpack_public_path__ + "static/media/navbar-userplaceholder.6e79f8a7.svg";